import ChartFavoritesDB from 'src/fb/chartFavorites-db';
import { bindDataBaseStore, unbindDataBaseStore } from 'src/utils/FirestoreUtils';

export default {

  /**
   * Fetch chart favorites
   */
  async bindChartFavoritesLocal({ clientId }) {
    this.chartFavoritesLocalLoaded = false;
    // Drop the previous client's favorites now, so nothing stale renders until the new snapshot arrives.
    this.chartFavoritesLocal = [];
    const chartFavouritesDb = new ChartFavoritesDB();
    const ref = chartFavouritesDb.getQuery([
      ['client', '==', clientId],
      ['scope', '==', 'client'],
      ['package', '==', null],
    ]);
    try {
      return await bindDataBaseStore({ store: this, property: 'chartFavoritesLocal' }, ref, []);
    } finally {
      this.chartFavoritesLocalLoaded = true;
    }
  }, // bindChartFavoritesLocal()

  async bindChartFavoritesRegional({ clinicId }) {
    this.chartFavoritesRegionalLoaded = false;
    const chartFavouritesDb = new ChartFavoritesDB();
    const ref = chartFavouritesDb.getQuery([
      ['clinic', '==', clinicId],
      ['scope', '==', 'clinic'],
      ['package', '==', null],
    ]);
    try {
      return await bindDataBaseStore({ store: this, property: 'chartFavoritesRegional' }, ref, []);
    } finally {
      this.chartFavoritesRegionalLoaded = true;
    }
  }, // bindChartFavoritesRegional()

  bindChartFavoritesGlobal() {
    const chartFavouritesDb = new ChartFavoritesDB();
    const ref = chartFavouritesDb.getQuery([
      ['scope', '==', 'global'],
      ['package', '==', null],
    ]);
    return bindDataBaseStore({ store: this, property: 'chartFavoritesGlobal' }, ref, []);
  }, // bindChartFavoritesGlobal()

  unbindChartFavoritesLocal() {
    this.chartFavoritesLocalLoaded = false;
    return unbindDataBaseStore({ store: this, property: 'chartFavoritesLocal' }, []);
  }, // unbindChartFavoritesLocal()

  unbindChartFavoritesRegional() {
    this.chartFavoritesRegionalLoaded = false;
    return unbindDataBaseStore({ store: this, property: 'chartFavoritesRegional' }, []);
  }, // unbindChartFavoritesRegional()

  unbindChartFavoritesGlobal() {
    return unbindDataBaseStore({ store: this, property: 'chartFavoritesGlobal' }, []);
  }, // unbindChartFavoritesGlobal()

  logout() {
    this.unbindChartFavoritesLocal();
    this.unbindChartFavoritesRegional();
    this.unbindChartFavoritesGlobal();
  }, // logout()

};
